import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from '../pop-denied-access'

let guard = () => new Promise((resolve, reject) => {
  return (
    find(store.getters['auth/abilities'], ability =>
      ability.name === 'manage-recurring-jobs' &&
      ability.entity_type === 'Billow\\Models\\RecurringJob'
    )
  ) ? resolve() : accessDeniedToaster(reject, {
    name: 'dashboard'
  })
})

export default {
  name: 'manage-recurring-jobs',
  run: guard
}